import $ from "jquery";
import "slick-carousel";

const sliderDiensten = () => {
  if (window.innerWidth <= 1024) {
    $(".diensten-cards-3")
      .not(".slick-initialized")
      .slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        centerMode: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 1025,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              variableWidth: false,
              arrows: false,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: false,
              arrows: false,
            },
          },
          {
            breakpoint: 601,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: false,
              arrows: false,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: false,
              arrows: false,
            },
          },
        ],
      });
  } else {
    if ($(".diensten-cards-3").hasClass("slick-initialized")) {
      $(".diensten-cards-3").slick("unslick");
    }
  }
};

$(window).on("resize", function () {
  sliderDiensten();
});

$(document).ready(function () {
  sliderDiensten();
});
